import type { MappedServiceObjectData } from 'common/models';
import type { ServiceObjectInCustomer } from 'pages/serviceObjects/models';
import React from 'react';

import ServiceObjectSectionItem from './ServiceObjectSectionItem';

interface Props {
  reportData: MappedServiceObjectData;
  serviceObject: ServiceObjectInCustomer;
  columnsWidthArray?: string[];
}

const ServiceObjectSubSection: React.FC<Props> = (props): React.ReactElement => {
  const { reportData, serviceObject, columnsWidthArray } = props;

  return (
    <div className="ServiceObjectSubSection">
      <div className="SectionTitle">{reportData.title}</div>
      <div
        className={`SectionContent ${!columnsWidthArray ? `cols-${reportData.columns || 1}` : ''}`}
      >
        {reportData.serviceObjectData?.map((field, i) => (
          <ServiceObjectSectionItem
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            index={i}
            reportData={field}
            serviceObject={serviceObject}
            columnsWidthArray={columnsWidthArray}
          />
        ))}
      </div>
    </div>
  );
};

export default ServiceObjectSubSection;
